import { app } from './Api';

const getContacts = async (data) => {
    return app.get('contact', { params: data });
};
const getContactById = async (id) => {
    return app.get(`contact/${id}`);
};
const postContact = async (data) => {
    return app.post('contact', data);
};
const updateContact = async (id, data) => {
    return app.put(`contact/${id}`, data);
};
const deleteContact = async (id) => {
    return app.delete(`contact/${id}`);
};

export { getContacts, getContactById, postContact, updateContact, deleteContact };
